export default function About() {
  return (
    <section id="about" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="mb-8">
          <span className="text-purple-600 text-sm font-medium">• Who We Are</span>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16">
          <div className="lg:col-span-2">
            <p className="text-5xl text-gray-800 font-light leading-relaxed" style={{ lineHeight: '1.8' }}>
              PLENUS d.o.o. represents a collective of passionate iOS developers and designers dedicated to transforming mobile experiences through innovative applications.
            </p>
          </div>
          
          <div className="lg:col-span-3 flex flex-col justify-center">
            <p className="text-lg text-gray-600 leading-relaxed mb-12">
              Our expertise spans security solutions and system optimization tools. We believe in creating applications that not only meet user needs but exceed expectations through intuitive design and robust functionality. Every line of code we write is crafted with precision, ensuring our products deliver exceptional performance and reliability.
            </p>
            
            <div className="flex items-center gap-6">
              <div className="flex -space-x-4">
                {[1, 2, 3, 4].map((i) => (
                  <div 
                    key={i}
                    className="w-16 h-16 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 border-4 border-white flex items-center justify-center"
                  >
                    <i className="ri-user-line text-white text-xl"></i>
                  </div>
                ))}
              </div>
              <span className="text-gray-700 font-medium">Expert Development Team</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}